import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Paper,
  Grid,
  Button,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import ReasonCodeTable from "./ViewReasonCodeTable";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import moment from "moment";

const ViewReasonCode = ({ openReasonCode, setOpenReasonCode, rowInfo }) => {
  const [tableLoading, setTableLoading] = useState(false);
  const [reasonCodeList, setReasonCodeList] = useState([]);
  const [error, setError] = useState(false);

  const { scheduleLineDetails } = rowInfo;
  const { schrockenSLID } = scheduleLineDetails;

  useEffect(() => {
    setTableLoading(true);
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllReasonCodesForSL/${schrockenSLID}`
      )
      .then((res) => {
        if (res.data.status) {
          setReasonCodeList(res?.data?.data?.reasonCodeList || []);
        } else {
          setError(true);
        }
      })
      .catch(() => setError(true))
      .finally(() => setTableLoading(false));
  }, [schrockenSLID]);

  return (
    <Dialog
      open={openReasonCode}
      onClose={() => setOpenReasonCode(false)}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "10px",
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
          backgroundColor: "#f8f9fa",
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        style={{
          padding: "16px 24px",
          borderBottom: "2px solid #ddd",
          backgroundColor: "#ffffff",
        }}
      >
        <Typography
          variant="h6"
          style={{
            fontWeight: 600,
            color: "#333",
            textAlign: 'center',
            flexGrow: 1,
            fontSize: "23px",
          }}
        >
          List of Reason Codes for PO {rowInfo.scheduleLineDetails.scheduleAgreementNumber}
        </Typography>

        {/* Updated Cancel Button */}
        <Typography
          onClick={() => setOpenReasonCode(false)}
          style={{
            textTransform: 'none',
           fontSize: "1rem",
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            padding: '6px 12px',
            cursor: "pointer",
          }}
        >
          Cancel
          <CloseIcon style={{
            color: "#FF0000",
            marginLeft: '4px'
          }}
             fontSize="large" />
        </Typography>
      </Box>

      <DialogContent style={{ padding: "24px", backgroundColor: "#fff" }}>
        <Paper
          elevation={3}
          style={{
            padding: "16px",
            borderRadius: "8px",
            border: "1px solid #E0E0E0",
            backgroundColor: "#f2f8fb",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            marginBottom: 20
          }}
        >
          <Grid container spacing={3} direction="row" justifyContent="space-around">
            <Grid item>
              <Typography
                variant="body1"
                style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}
              >
                Sponsor Name
              </Typography>
              <Typography variant="body2" style={{ color: "#555" }}>
                {rowInfo?.scheduleLineDetails?.sponsorName || ""}
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                variant="body1"
                style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}
              >
                CMO
              </Typography>
              <Typography variant="body2" style={{ color: "#555" }}>
                {rowInfo?.scheduleLineDetails?.vendorName || ""}
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                variant="body1"
                style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}
              >
                Plant ID
              </Typography>
              <Typography variant="body2" style={{ color: "#555" }}>
                {rowInfo?.scheduleLineDetails?.vendorPlant || ""}
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                variant="body1"
                style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}
              >
                Product Code / Description
              </Typography>
              <Typography variant="body2" style={{ color: "#555" }}>
                {rowInfo?.scheduleLineDetails?.fgMaterialCode &&
                  rowInfo?.scheduleLineDetails?.fgMaterialName ?
                  `${rowInfo?.scheduleLineDetails?.fgMaterialCode} / ${rowInfo?.scheduleLineDetails?.fgMaterialName}`
                  : ""}
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        <ReasonCodeTable
          reasonCodeList={reasonCodeList}
          tableLoading={tableLoading}
          error={error}
          dateFormat={(date) => moment(date).format("DD-MMM-YYYY").toUpperCase()}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ViewReasonCode;